export class CreateBookingCommand {
  constructor(booking) {
    Object.assign(this, booking);
    this.newCustomerInfo = undefined;
  }

  addNewCustomerInfo(bookingCustomer) {
    this.newCustomerInfo = bookingCustomer;
  }
}
